module.exports = __webpack_public_path__ + "img/5-en.1149caa6.png";